import { Constants } from '@constants';
import { IconPhonecall } from '@iwoca/icons/brand';
import { Flex, Stack, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { showIntercomMessenger } from '../../../../../../../../../../iwIntercom/IntercomHelper';

// The account manager marks this requirement as complete after the call, so there's nothing to submit here.
export const ApplicantCallPage = () => (
    <Stack gap="section">
        <Stack>
            <Text className="text-3xl font-bold">
                <FormattedMessage
                    id="_.funding_requirements_v2.applicant_call.title"
                    defaultMessage="Give us a quick call"
                />
            </Text>
            <Text className="text-xl">
                <FormattedMessage
                    id="_.funding_requirements_v2.applicant_call.subtitle"
                    defaultMessage="Please contact your personal advisor to discuss the final steps."
                />
            </Text>
        </Stack>
        {/* ORION-113-GAP token: no surface for the structure-95 grey */}
        <Stack padding="nested" radius="nested" className="bg-structure-95">
            {/* ORION-113-GAP component: Flex has one gap for both
                    directions, so wrapped lines are 12px apart on phones
                    rather than the design's 8px */}
            <Flex wrap="wrap" align="center">
                <IconPhonecall width={24} height={24} aria-hidden />
                <a
                    href={Constants.PHONE_NUMBER.tel}
                    className="font-bold text-primary-10"
                >
                    {Constants.PHONE_NUMBER.display}
                </a>
                <Text>
                    <FormattedMessage
                        id="_.funding_requirements_v2.applicant_call.opening_hours"
                        defaultMessage="Monday - Friday (8:00 AM - 6:00 PM)"
                    />
                </Text>
            </Flex>
            <Text>
                <FormattedMessage
                    id="_.funding_requirements_v2.applicant_call.callback"
                    defaultMessage="Outside our office hours? Request a callback via <chat>chat</chat> or <email>email</email>."
                    values={{
                        chat: (chunks) => (
                            <button
                                type="button"
                                onClick={showIntercomMessenger}
                                className="text-primary-40 underline"
                            >
                                {chunks}
                            </button>
                        ),
                        email: (chunks) => (
                            <a
                                href={`mailto:${Constants.EMAIL}`}
                                className="text-primary-40 underline"
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </Text>
        </Stack>
    </Stack>
);
